import * as React from "react";
import { CourseInstructionPartOperations } from "../../../../../../course-author/instruction/parts/CourseInstructionPart.types";
import { HTMLEditor } from "../../../../../../course-author/html-editor/Editor.container";
import { HTMLRenderer } from "../../../../../../course-author/html-editor/Renderer";
import { AnswerBox, ClickableText } from "../../../../../../course-author/instruction/parts/exercises/FormatElements";
import { IClozeGapLocalized } from "../../../../../../course-author/types";
import { PreferredLocale } from "../../../../../../../utils/locales";
import AddGapButton from "./AddGapButton";
import { EditGaps } from "./EditGaps";
import { BackendGapTag, convertBackendTemplateToFrontendFormat, convertFrontendTemplateBackendFormat } from "./util";

export interface IEditClozeProps {
  currentLocale: PreferredLocale;
  template: string;
  gaps: IClozeGapLocalized[];
  partOperations: CourseInstructionPartOperations;
}

export interface IEditCloseState {
  editTemplate: boolean;
}

export default class EditCloze extends React.Component<IEditClozeProps, IEditCloseState> {
  public containerRef = React.createRef<HTMLDivElement>();

  constructor(props: IEditClozeProps) {
    super(props);
    this.state = {
      editTemplate: false,
    };
  }

  public toggleEditTemplate = () => this.setState({ editTemplate: !this.state.editTemplate });

  public saveTemplate = (template: string) => {
    const { currentLocale, partOperations, gaps } = this.props;
    const formattedTemplate = convertFrontendTemplateBackendFormat(template);
    const gapCount = formattedTemplate.split(BackendGapTag).length - 1;
    if (gapCount > gaps.length) {
      partOperations.addClozeGap(gapCount - gaps.length);
    }

    if (formattedTemplate !== this.props.template) {
      partOperations.modifyClozeTemplate(formattedTemplate, currentLocale);
    }
    this.toggleEditTemplate();
  };

  public getTemplate = () => convertBackendTemplateToFrontendFormat(this.props.template);

  public render() {
    const { currentLocale, template, gaps, partOperations } = this.props;

    const templateLength = template.split(BackendGapTag).length - 1;

    return (
      <>
        <AnswerBox>
          <ClickableText shouldDisplay={!this.state.editTemplate} onClick={this.toggleEditTemplate}>
            <HTMLRenderer source={this.getTemplate()} />
          </ClickableText>
          {this.state.editTemplate && (
            <div ref={this.containerRef}>
              <HTMLEditor
                getContent={this.getTemplate}
                setContent={this.saveTemplate}
                toolbarCustomButtons={[<AddGapButton key={0} />]}
                currentLocale={this.props.currentLocale}
                shouldAutoFocus={true}
                containerRef={this.containerRef}
              />
            </div>
          )}
        </AnswerBox>
        <EditGaps
          currentLocale={currentLocale}
          gaps={gaps}
          templateLength={templateLength}
          deleteGap={partOperations.deleteClozeGap}
          modifyClozeGapAnswers={partOperations.modifyClozeGapAnswers}
          modifyClozeGapHint={partOperations.modifyClozeGapHint}
        />
      </>
    );
  }
}
